import React, { Component } from 'react';
import { createApiUrl } from './api';

class AddPage extends Component {
  constructor() {
    super();
    this.state = {
      data: '',
      type: 'pilots',
      error: false,
      success: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.addItems = this.addItems.bind(this);
    this.onSelectType = this.onSelectType.bind(this);
  }
  onSelectType(event) {
    this.setState({
      type: event.target.value,
    });
  }
  addItems() {
    const lines = this.state.data.split('\n');
    const type = this.state.type;
    this.setState({ success: false, error: false });
    Promise.all(
      lines.map(image => {
        const data = { image };
        const url = createApiUrl(`/${type}`);
        console.log(`Posting to ${url}:`, data.name, data);
        return fetch(url, {
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify(data),
          method: 'POST',
          mode: 'cors',
        });
      })
    )
      .then(response => {
        this.setState({
          data: '',
          success: true,
        });
      })
      .catch(e => {
        console.error('ERROR', e);
        this.setState({
          error: true,
        });
      });
  }
  handleChange(e) {
    this.setState({
      data: e.target.value,
    });
  }
  render() {
    return (
      <div>
        {this.state.success && (
          <div className="alert alert-success" role="alert">
            All items have been added!
          </div>
        )}
        {this.state.error && (
          <div className="alert alert-danger" role="alert">
            Something went wrong :(
          </div>
        )}
        <p>Add new items by specifying image URLs. Please fill in one URL per line.</p>
        <div>
          Item type:{' '}
          <select value={this.state.type} onChange={this.onSelectType}>
            <option value="pilots">Pilot</option>
            <option value="upgrades">Upgrade</option>
          </select>
        </div>
        <div>
          <textarea
            onChange={this.handleChange}
            defaultValue={this.state.data}
            style={{ width: 500, height: 500 }}
          />
        </div>
        <div>
          <button onClick={this.addItems}>Add Items</button>
        </div>
      </div>
    );
  }
}

export default AddPage;



// WEBPACK FOOTER //
// ./src/AddPage.js